<template>
  <div class="media skeleton p-l-10 p-b-10" style="background: none">
    <div class="col-sm-7 col-md-8 p-l-15">
      <div class="row">
        <div class="skeleton-part-lg max-width-xl" />
      </div>
      <div class="row">
        <div class="skeleton-part-sm m-r-5" style="width: 12%; background: #777" />
        <div class="skeleton-part-sm m-r-5" style="width: 16%; background: #777" />
      </div>
    </div>
    <div class="col-sm-5 col-md-4">
      <div class="skeleton-button skeleton-part-lg skeleton-width-md" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.skeleton-button {
  background: #f0f0f0;
}
</style>
